module.exports = __webpack_public_path__ + "bf9a8eea8822a0add22b2d8a221b8a95.png";